import React, { FC, useRef } from "react"
import useClickOutside from "../../../helpers/useClickOutside"
import styled from "styled-components"
import deliverClubIcon from "../../../static/icons/delivery_icon copy.png"
import devicesIcon from "../../../static/icons/devices_icon.png"
import domclickIcon from "../../../static/icons/domclick.png"
import logisticsIcon from "../../../static/icons/logisticks.png"
import okkoIcon from "../../../static/icons/okko_icon.png"
import prymeIcon from "../../../static/icons/pryme_icon.png"
import sberIcon from "../../../static/icons/sber_icon.png"
import sbermarketIcon from "../../../static/icons/sbermarket_icon.png"
import sbermobileIcon from "../../../static/icons/sbermobile.png"
import sberstrakhIcon from "../../../static/icons/sberstrakh.png"
import spasiboIcon from "../../../static/icons/spasibo.png"
import zvukIcon from "../../../static/icons/zvuk.png"

const ContentStyle = styled.div`
  display: grid;
  width: 100%;
  margin-bottom: 34px;
  grid-template-columns: repeat(3, 33%);
  grid-row-gap: 20px;
`

const ItemStyle = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  text-decoration: none !important;
`

const IconStyle = styled.span`
  margin-bottom: 8px;

  img {
    width: 48px;
    height: 48px;
  }
`

const TitleStyle = styled.span`
  width: 100%;
  overflow: hidden;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: #494e53;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const MoreStyle = styled.a`
  text-decoration: none !important;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #000014;
`

interface IService {
  src: string
  href: string
  text: string
  alt: string
}

interface IEcosystemMenu {
  isVisible: boolean
  onClose: () => void
}

const services: IService[] = [
  {
    src: sberIcon,
    href: "https://sberbank.ru/",
    text: "Сбербанк",
    alt: "sber-icon",
  },
  {
    src: prymeIcon,
    href: "https://sber.ru/sberprime",
    text: "СберПрайм",
    alt: "sber-prime-icon",
  },
  {
    src: sbermarketIcon,
    href: "https://sbermarket.ru/",
    text: "СбербМаркет",
    alt: "sber-market-icon",
  },
  {
    src: okkoIcon,
    href: "https://okko.tv/",
    text: "Окко",
    alt: "okko-icon",
  },
  {
    src: domclickIcon,
    href: "https://domclick.ru/",
    text: "Домклик",
    alt: "domclick-icon",
  },
  {
    src: spasiboIcon,
    href: "https://spasibosberbank.ru/",
    text: "Спасибо",
    alt: "spasibo-icon",
  },
  {
    src: sberstrakhIcon,
    href: "https://www.sberbank-insurance.ru/",
    text: "СберСтрахование",
    alt: "sber-insurance-icon",
  },
  {
    src: sbermobileIcon,
    href: "https://sbermobile.ru/",
    text: "СберМобайл",
    alt: "sber-mobile-icon",
  },
  {
    src: logisticsIcon,
    href: "https://sblogistica.ru/",
    text: "СберЛогистика",
    alt: "sber-logistica-icon",
  },
  {
    src: deliverClubIcon,
    href: "https://www.delivery-club.ru/",
    text: "Delivery Club",
    alt: "delivery-club-icon",
  },
  {
    src: zvukIcon,
    href: "https://zvk.onelink.me/dd8d/f429c97e",
    text: "СберЗвук",
    alt: "sber-zvk-icon",
  },
  {
    src: devicesIcon,
    href: "https://sber.ru/salute",
    text: "СберДевайсы",
    alt: "sber-device-icon",
  },
]

export const EcosystemMenu: FC<IEcosystemMenu> = ({ isVisible, onClose }) => {
  const ref = useRef(null)
  useClickOutside(ref, onClose)

  return (
    <div className={`ecosystem ${isVisible && "active"}`} ref={ref}>
      <ContentStyle>
        {services.map((service, index) => (
          <ItemStyle href={service.href} target="_blank" key={index}>
            <IconStyle>
              <img src={service.src} alt={service.alt} />
            </IconStyle>
            <TitleStyle>{service.text}</TitleStyle>
          </ItemStyle>
        ))}
      </ContentStyle>
      <MoreStyle
        href="https://sber.ru/?_ga=2.14700918.1515700328.1603891383-601128071.1602772824"
        target="_blank"
      >
        Больше об экосистеме Сбера >
      </MoreStyle>
    </div>
  )
}
